<div class="main">
  <div class="btn-area">
    <button *ngIf="!auth.isYakuin" type="button" (click)="onDelete()" class="delete">{{'delete' | translate}}</button>
    <div style="display: flex;">
      <button type="button" (click)="onClose()" class="cancel">{{'cancel' | translate}}</button>
      <button *ngIf="!auth.isYakuin" type="button" (click)="onSubmit()" class="submit">{{'save' | translate}}</button>
    </div>
  </div>
  <form [formGroup]="editUserForm" autocomplete="off" style="margin-left: 11.8%; width: 76.4%;">
    <div class="field-class">
      <span class="field-label">ID</span>
      <input type="text" class="input-field" id="id" [value]="userID" matInput readonly>
    </div>
    <div class="field-class">
      <span class="field-label">* {{'userName' | translate}}</span>
      <input type="text" class="input-field" matInput required id="name" placeholder="Enter User Name" formControlName="name">
        <div *ngIf="editUserForm.get('name')?.invalid && editUserForm.get('name')?.touched" class="error-message">
          <div *ngIf="editUserForm.get('name')?.hasError('required')">This Field is Required</div>
        </div>
    </div>
    <div class="field-class">
      <span class="field-label">{{'firstName' | translate}}</span>
      <input type="text" class="input-field" matInput required id="firstName" placeholder="Enter First Name" formControlName="first_name">
    </div>
    <div class="field-class">
      <span class="field-label">{{'lastName' | translate}}</span>
      <input type="text" class="input-field" matInput required id="lastName" placeholder="Enter Last Name" formControlName="last_name">
    </div>
    <div class="field-class">
      <span class="field-label">{{'companyName' | translate}}</span>
      <input type="text" class="input-field" matInput [value]="getCompanyName()" readonly>
    </div>
    <div class="field-class">
      <span class="field-label">{{'vessel' | translate}}</span>
      <p-dropdown 
        [ngClass]="'vessel_dropdown'"
        [options]="filteredVesselList" 
        [filter]="true"
        filterBy="name"
        displayProperty="name"
        [showClear]="true"
        [(ngModel)]="selectedVessel"
        [ngModelOptions]="{standalone: true}"
        optionLabel="name"
        [virtualScroll]="true" 
        [virtualScrollItemSize]="38"
        [style]="{'width': '100%', 'height': '40px', 'font-size': '18px', 'background-color': 'var(--list-bg-color)', 'padding-left': '5px', 'color': 'var(--text-color)'}"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption >
          <div style="margin-top: -6px;">
            {{selectedVessel.name}}
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="field-class">
      <span class="field-label">{{'position' | translate}}</span>
      <input type="text" class="input-field" id="position" formControlName="position" placeholder="Enter Job Title" matInput>
    </div>
    <div class="field-class">
      <span class="field-label" style="display: flex; justify-content: space-between; height: 17.5px; overflow-y: visible; z-index: 999;">
        {{'email' | translate}}
        <img class="email-icon"/>
      </span>
      <input type="text" class="input-field" id="email" formControlName="email" matInput readonly>
    </div>
    <div class="field-class">
      <span class="field-label" style="display: flex; justify-content: space-between; height: 17.5px; overflow-y: visible; z-index: 999;">
        {{'phone' | translate}}
        <img class="tel-icon"/>
      </span>
      <input type="text" class="input-field" id="telephone" formControlName="telephone" placeholder="Enter Phone No." matInput>
    </div>
    <div class="field-class">
      <span class="field-label" style="display: flex; justify-content: space-between; height: 17.5px; overflow-y: visible; z-index: 999;">
        {{'fax' | translate}}
        <img class="fax-icon"/>
      </span>
      <input type="text" class="input-field" id="fax" formControlName="fax" placeholder="Enter Fax No." matInput>
    </div>
    <div class="field-class">
      <span class="field-label">{{'address' | translate}}</span>
      <input type="text" class="input-field" id="address" formControlName="address" placeholder="Enter Address" matInput>
    </div>
    <div class="field-class">
      <span class="field-label">{{'oid' | translate}}</span>
      <input type="text" class="input-field" id="oid" formControlName="oid" matInput readonly>
    </div>
    <div 
      style="font-family: Noto Sans JP; margin: 5px 0 10px 0; color: var(--text-color); font-size: 14px; display: flex; align-items: center"
    >
      <input
        *ngIf="!isOWUUserRegistered"
        type="checkbox"
        [(ngModel)]="isRegisteringOWUUserChecked"
        [ngModelOptions]="{standalone: true}"
        style="margin-right: 6px; margin-top: 2px"
      />
      {{ "registerOWU" | translate }}
    </div>
    <div class="tenant-field">
      <span class="tenant-label">{{'tenants' | translate}}</span>
      <span class="field-label">Current tenant access</span>
      <span class="tenant-value">
        {{ getCurrTenantName() }}
        <button *ngIf="!isGlobalAdmin" class="tenant-button" (click)="onChangeTenant()">
          Change tenant
        </button>
      </span>
      <span class="field-label" style="margin-top: -7px;">{{'role' | translate}}</span>
      <p-dropdown
        [ngClass]="'role_dropdown'"
        [options]="roles" 
        placeholder="Select Role" 
        formControlName="role_id"
        [(ngModel)]="selectedRole" 
        displatProperty="name"
        [required]="true"
        (onChange)="onRoleChange($event)"
        [style]="{'background-color': 'white', 'height': '28px', 'border-radius': '0.25rem', 'padding': '0 0.5rem', 'width': '100%'}"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption >
          <div>{{ selectedRole?.name }}</div>
        </ng-template>
        <ng-template let-role pTemplate="item" >
          {{ role?.name }}
        </ng-template>
      </p-dropdown>
    </div>
  </form>
</div>